var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "bm__pered" }, [
    _c(
      "button",
      {
        staticClass: "btn btn--blue",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _setup.emit("input")
          },
        },
      },
      [
        _vm._v("\n        " + _vm._s(_setup.props.text) + "\n        "),
        _setup.props.ob.wait
          ? _c(_setup.Dots, { staticClass: "bm__dots" })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _setup.props.ob.message
      ? _c("div", { staticClass: "bm__message" }, [
          _vm._v("Ошибка: " + _vm._s(_setup.props.ob.message)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }